/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPBANKACCOUNTTYPE = {
    Cheque: '01',
    Savings: '02'
} as const;
export type IAPBANKACCOUNTTYPE = typeof IAPBANKACCOUNTTYPE[keyof typeof IAPBANKACCOUNTTYPE];


export function IAPBANKACCOUNTTYPEFromJSON(json: any): IAPBANKACCOUNTTYPE {
    return IAPBANKACCOUNTTYPEFromJSONTyped(json, false);
}

export function IAPBANKACCOUNTTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPBANKACCOUNTTYPE {
    return json as IAPBANKACCOUNTTYPE;
}

export function IAPBANKACCOUNTTYPEToJSON(value?: IAPBANKACCOUNTTYPE | null): any {
    return value as any;
}

